{
  "en": {
    "pupilProjectStatus": {
      "switchError": "Error switching project",
      "switchModal": {
        "joinAnotherClassroom": "Log out and switch to a different shared space",
        "loading": "Loading available projects...",
        "noOtherProjects": "No other projects are available in this space.",
        "selectProject": "Your content will be saved in this project:",
        "selectProjectPlaceholder": "Choose a project to switch to",
        "title": "Project Assignment"
      },
      "changeProject": "Change project",
      "logoutError": "Error logging out",
      "switchSuccess": "Successfully switched project"
    }
  }
}
